export default __webpack_public_path__ + "static/news4-c5acbec9d798ad044c33daee97a165b2.jpeg";